<template>
	<div :id="baseId" class="product-perks-panel d-flex flex-column">
		<div class="product-perks-panel-wrapper">
			<div id = 'purple' :style="{'background-image': 'url(' + require('@/assets/images/home/v8/slant.png') + ')'}"></div>
			<div class="slide_header">
				<h1> The Simplest Way to Start an Online Business <span>💰</span></h1>
				<h2> See how Stan helps you go from setup to sales in minutes. </h2>
			</div>
			<div class="product-perks-panel-content d-flex flex-column">
				<div id = 'lottie' ref="lottieContainer"></div>
			</div>
		</div>
	</div>
</template>
<script setup>
	import { onMounted, ref, defineProps, computed, onUnmounted } from 'vue'
	import lottie from 'lottie-web'

	const props = defineProps({
		id: {
			type: [String, Number],
		},
		activeComponent: { type: Boolean },
	})

	const lottieContainer = ref(null)
	let applyShadow = () => {}
	let animation

	onMounted(() => {
		if (lottie && lottieContainer.value) {
			animation = lottie.loadAnimation({
			container: lottieContainer.value,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			path: '/images/home/v8/Stan_Lottie.json',
			})

			applyShadow = () => {
				const svgElement = lottieContainer.value.querySelector('svg')
				if (svgElement) {
					svgElement.style.filter = 'drop-shadow(0px 10px 30px rgba(0, 0, 0, 0.2))'
				}
			}

			animation.addEventListener('DOMLoaded', applyShadow)
		}
	})

	onUnmounted(() => {
		if (animation) {
			animation.removeEventListener('DOMLoaded', applyShadow)
			animation.destroy()
		}
	})

	const baseId = computed(() => `${props.id}`)
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/helpers-v6.scss';

	.slide_header{
		margin: 52px auto 0px auto;
		position: relative;
		color: white;
		text-shadow: 0 4px 10px rgba(black, 0.1);
		margin-bottom: 0;

		h1{
			font-weight: 700;
		}
	}

	#lottie{
		max-width: 100%;
		width: 130vh;
		aspect-ratio: 3/2;
	}

	#purple{
		background-size: 100% 100%;
		background-repeat: no-repeat;
		position: absolute;
		top: 0;
		left: 0;
		height: 90vh;
		width: 100vw;
	}

	.product-perks-panel-wrapper{
		position: relative;
		padding-bottom: 20px;
	}

	@media (max-width: 800px) {

		.product-perks-panel{
			padding-bottom: 100px !important;
		}

		#purple{
			height: 76vh;
		}

		#lottie{
			width: 100vw;
		}
	}


	.product-perks-panel {
		background: white;
		font-family: Plus Jakarta Sans, sans-serif;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-bottom: 0;
		position: relative;
		@media (max-width: 767px) {
			& {
				padding-top: 40px;
				overflow: hidden;
			}
		}

		&-wrapper {
			h3,
			p {
				font-family: Plus Jakarta Sans, sans-serif;
				font-style: normal;
				color: #131f60;
			}
			.trial-button {
				margin-top: 4rem;
			}
			h3 {
				font-weight: 800;
				font-size: 36px;
				line-height: 45px;
				text-align: center;
				letter-spacing: -0.01em;
				margin-bottom: 23px;
				@media (max-width: 767px) {
					font-size: 22px;
					line-height: 28px;
					letter-spacing: 0;
					padding-left: 43px;
					padding-right: 45px;
					margin-bottom: 10px;
					margin-left: 0;
					span {
						display: none;
					}
					span + span {
						display: inline-flex !important;
					}
				}
			}

			p {
				font-weight: 500;
				font-size: 20px;
				line-height: 130%;
				text-align: center;
				letter-spacing: -0.01em;
				margin-bottom: 63px;
				@media (max-width: 767px) {
					font-weight: 400;
					font-size: 14px;
					width: 95%;
					padding-left: 40px;
					padding-right: 24px;
					margin-left: 0;
					margin-bottom: 50px;
				}
			}
		}

		&-content,
		&-action {
			display: flex !important;
			justify-content: center;
			align-items: center;
		}

		img {
			box-shadow: 0px 20px 60px rgba(black, 0.1);
			border-radius: 20px;
			height: 72vh;
			width: fit-content;
		}

		&-action {
			.panel-button {
				width: 330px;
				height: 75px;
				background: #131f60;
				box-shadow: 0 40px 40px rgba(0, 0, 0, 0.1);
				border: none;
				border-radius: 50px;
				cursor: pointer;
				transition: 0.2s ease;
				&:hover {
					background: #090e2a;
				}
				&-content {
					display: flex;
					align-items: center;
					padding-left: 30px;
					padding-right: 28px;
					padding-bottom: 2px;
					&--text {
						font-family: 'Plus Jakarta Sans', sans-serif;
						font-style: normal;
						font-weight: 600;
						font-size: 22px;
						line-height: 105%;
						color: #ffffff;
						margin-right: auto;
					}
					&--image {
						margin-left: auto;
					}
				}
			}
		}

		@media (max-width: 767px) {
			&-content {
				img {
					width: 90vw;
					height: fit-content;
				}
			}
			&-action {
				.panel-button {
					width: 323px;
					height: 60px;
					margin-top: 2rem !important;
					&-content {
						padding-left: 20px;
						padding-right: 18px;
						&--text {
							padding-top: 4px;
							font-size: 16px;
						}
						&--image {
							svg {
								width: 14px;
								height: 14px;
							}
						}
					}
				}
			}
		}
	}
</style>
